import Vue from 'vue'
export const NOTIFICATION_INFO = 'NOTIFICATION_INFO'
export const TEMPLATE_MODIFIED = 'TEMPLATE_MODIFIED'
export const TEMPLATE_FIRST = 'TEMPLATE_FIRST'
export const TEMPLATE_SAVE = 'TEMPLATE_SAVE'
export const TEMPLATE_LOADING = 'TEMPLATE_LOADING'
export const TEMPLATE_DELETING = 'TEMPLATE_DELETING'
export const PAYMENT_INFO = 'PAYMENT_INFO'
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/model/EventBus.js